import terraceStyles from "./styles/Terrace.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import React, {useContext} from "react";
import {StoreContext} from "../../../stores/StoreLoader";
import classNames from 'classnames';
import {isDescendantOrEq} from "../../../utils/DataUtilities";

export function EditButton(props: {
    contentItem: ContentItem,
    className?: string,
    handleSave: (contentItem: ContentItem, organization: BaseOrganization) => void,
    handleDelete: (contentItem: ContentItem) => void,
}) {
    const {userStore, sidebarStore, organizationStore} = useContext(StoreContext);

    const editButtonClassName = classNames({
        [terraceStyles.editButton]: true,
        [props.className || ""]: props.className,
    })

    const currentUserCanModifyAtCurrentOrganization = userStore.isEditor &&
        props.contentItem.is_custom &&
        props.contentItem.organization &&
        isDescendantOrEq(props.contentItem.organization.path, organizationStore.currentOrganization.path);

    return currentUserCanModifyAtCurrentOrganization ? <button aria-label={"Edit Item"} className={editButtonClassName} onClick={async e => {
            e.stopPropagation();
            await sidebarStore.setSidebar({
                view: "SchoolFeedPost",
                contentItem: props.contentItem,
                handleSave: props.handleSave,
                handleDelete: props.handleDelete,
            })
        }}>
            <FontAwesome ariaHidden prefix={'fas'} name={'fa-pencil-alt'} />
        </button> : <></>
}